import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from './loader.service';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  constructor(public loaderService: LoaderService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const skip = req.headers.get('X-Skip-Loader') === 'true';

    if (!skip) {
      this.loaderService.isLoading.next(true);
    }

    console.log(" HTTP_CALL ");

    const cleanReq = skip ? req.clone({ headers: req.headers.delete('X-Skip-Loader') }) : req;

    return next.handle(cleanReq).pipe(
      finalize(
        () => {
          if (!skip) this.loaderService.isLoading.next(false);
        }
      )
    );
  }
}
